import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Title }     from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(
        private meta: Meta,
        private titleService: Title,
    ) {

    }

    addMetaTags(seoArray){
        this.meta.addTags(seoArray);
    }
    setTitle(newTitle: string){
        this.titleService.setTitle(newTitle);
    }
}
